<template>
  <div class="text-block block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-image-icon white--text text-lg-2" />
            </div>

            <h4>
              Image
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <div class="block-card-body" v-if="validData">
          <form-validation
            v-model="errorsCount"
            :append="data.url && data.url.length ? 0 : 1"
          >
            <label>Insert image link</label>
            <v-text-field placeholder="Image Url" outline v-model="data.url" />
          </form-validation>
          <label><span class="text-bold">Or</span> Upload Your Image</label>
          <image-input
            :url="data.url"
            :canRemove="true"
            @onUploadComplete="handleImageUpload"
            @onFileRemove="handleImageRemove"
            :maxFiles="2"
            :maxFilesize="5"
            type="image/*"
          />
        </div>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
import imageInput from "./common-inner-blocks/image-uploader-dropzone";
export default {
  name: "CardImageUrl",
  components: {
    imageInput,
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
    };
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    handleImageUpload(e) {
      this.data.url = e[0].url;
    },
    handleImageRemove() {
      this.data.url = "";
    },
  },
};
</script>

<style scoped></style>
